/*
 * Panel del dashboard, réplica del .panel del HTML original
 */
import { Description, Title } from "codekit";

import { htmlTheme } from "./utils/carthelp";

/**
 * Renderiza un panel con encabezado y contenido
 * @param {Object} props Propiedades del componente
 * @param {string} props.title Título del panel
 * @param {React.ReactNode} props.hint Descripción o ayuda bajo el título
 * @param {React.ReactNode} props.children Contenido del panel
 */
const Panelbox = ({ title, hint, children }) => (
  <div
    style={{
      background: htmlTheme.card,
      borderRadius: 14,
      padding: "18px 20px 14px",
      border: `1px solid ${htmlTheme.border}`,
      boxShadow: "0 1px 3px rgba(20,30,70,.06)",
      marginBottom: 16,
    }}
  >
    <div style={{ color: htmlTheme.navy2, marginBottom: 4 }}>
      <Title variant="title-3">{title}</Title>
    </div>
    {hint ? (
      <div style={{ color: htmlTheme.muted, marginBottom: 10 }}>
        <Description variant="description-3">{hint}</Description>
      </div>
    ) : null}
    {children}
  </div>
);

export default Panelbox;
